<template>
  <div class="x-tablelist-view permission-list">
    <div class="search-warp">
      <el-input
        v-model="filter.accountname"
        clearable
        class="name-filter"
        :placeholder="$t('HT.subordinate.permission.accountPlaceholder')"
        @keyup.enter.native="search"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary" size="small" @click="search">{{ $t('HT.search') }}</el-button>
      <el-button plain size="small" @click="reset">{{ $t('HT.reset') }}</el-button>
    </div>
    <div class="x-table-box">
      <ux-table
        ref="table"
        :showPage="true"
        :hide-on-single-page="true"
        maxHeight="100%"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>

<script lang="jsx">
export default {
  name: 'PermissionList',
  props: {
    // 当前二级客户账号
    accounts: { type: Array, default: () => [] },
    // 产品权限分配列表总数
    total: { type: Number, default: 0 }
  },
  data() {
    return {
      // 客户权限列表筛选与分页参数
      filter: { accountname: '', page: 1, size: 10 }
    };
  },
  computed: {
    // ux-table 当前页接口数据和总数
    tableData() {
      return {
        totalSize: this.total,
        list: this.accounts
      };
    },
    columns() {
      return [
        {
          label: this.$t('HT.subordinate.permission.accountName'),
          minWidth: 190,
          align: 'left',
          prop: 'name'
        },
        {
          label: this.$t('HT.subordinate.common.level'),
          width: 80,
          render: (h, row) => h('el-tag', { props: { size: 'mini', type: 'primary' } }, [row.level])
        },
        {
          label: this.$t('HT.subordinate.permission.authorizedProductCount'),
          width: 125,
          align: 'center',
          prop: 'authorized_products',
          formatter: (row, column, cellValue) => {
            return cellValue || row.productCount || '0';
          }
        },
        {
          label: this.$t('HT.subordinate.permission.authorizedProducts'),
          minWidth: 300,
          align: 'left',
          render: (h, row) => {
            const productNames = row.productNames || [];
            if (!productNames.length) {
              return h('el-tag', { props: { size: 'mini', type: 'info' } }, [
                this.$t('HT.subordinate.permission.notConfigured')
              ]);
            }
            return h(
              'div',
              { class: 'product-tags' },
              productNames.map((name) =>
                h('el-tag', { props: { size: 'mini', type: 'primary' }, key: name }, [name])
              )
            );
          }
        },
        {
          label: this.$t('HT.orderManage.status'),
          width: 90,
          render: (h, row) =>
            h(
              'el-tag',
              { props: { size: 'mini', type: row.enabled ? 'success' : 'info' } },
              [
                row.enabled
                  ? this.$t('HT.addChannel.open')
                  : this.$t('HT.addChannel.close')
              ]
            )
        },
        {
          label: this.$t('HT.subordinate.permission.updatedTime'),
          width: 170,
          prop: 'updated_time',
          formatter: (row, column, cellValue) => cellValue || '—'
        },
        {
          label: this.$t('HT.operation'),
          width: 110,
          fixed: 'right',
          render: (h, row) =>
            h(
              'el-button',
              { props: { type: 'text' }, on: { click: () => this.$emit('configure', row) } },
              [this.$t('HT.subordinate.permission.configure')]
            )
        }
      ];
    }
  },
  methods: {
    // 触发客户权限查询
    search() {
      this.filter.page = 1;
      this.query();
    },
    // 清空搜索条件并恢复第一页
    reset() {
      this.filter = { accountname: '', page: 1, size: this.filter.size };
      this.query();
    },
    // 切换列表页码
    changePage(page) {
      this.filter.page = page;
      this.query();
    },
    // 切换列表分页大小
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.query();
    },
    // 按当前筛选条件请求产品权限分页列表
    query() {
      this.$emit('query', {
        accountname: this.filter.accountname.trim(),
        page: this.filter.page,
        size: this.filter.size
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.permission-list { min-height: 560px; }
.x-table-box { flex: 1; min-height: 0; }
.search-warp { display: flex; align-items: center; gap: 10px; margin-bottom: 18px; }
.name-filter { width: 260px; }
.export-button { margin-left: auto; }
.product-tags { display: flex; flex-wrap: wrap; gap: 4px; }
</style>
